<template>
    <div >
       <BaseModal
          v-if="visible" 
          ModalId="modalId"
          :HideModalFun="onHidden"
          :TitleWindow="winTitle"
          :width="'40%'"
          :height="'auto'"
          :buttons="[
              { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
              { text: $t('Shared.TitleOK'), variant: 'primary', action: onClickShowReport },                   
          ]"              
          @Close="close"
      >
            
         <b-row>
          <b-col lg="6" md="6" sm="12">
            <MdDateTime 
              :Label="$t('Shared.datefrom')" 
              :Model="dateFrom"                           
              @input="dateFrom = $event"                            
              :Id="'ItemRelocationtDateFrom'"
              :Type="'date'"  
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateFromValid">
            </MdDateTime>
          </b-col>
          <b-col lg="6" md="6" sm="12">
            <MdDateTime 
              :Label="$t('Shared.dateTo')" 
              :Model="dateTo"                           
              @input="dateTo = $event"                            
              :Id="'itemrelocationDateTo'"
              :Type="'date'"             
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateToValid">
            </MdDateTime>
          </b-col>
        </b-row>
        <b-row>
          <b-col>         
            <MdLookupMultiSelect
                v-bind:Label="$t('Medication.Drugs')"
                v-bind:ModelCode=DrugsCodeModel
                v-bind:RefCode="'DrugsCode'"
                v-bind:Api="'Drugs'"
                v-bind:FieldCode="'drugCode'"
                v-bind:FieldDescription="'drugname'"
                :SearchTitle="$t('Medication.Drugs')"
                :GetValues="getValuesDrugs"
                :InvalidFeedback="$t('Msg.InvalidCode')"
                :SearchFieldCode="'Code'"
                :AuxFields="AuxFieldsDrugs"
                :ServerSidePagination="true"
                v-bind:Fields="BaseFieldsDrugs"/>
          </b-col>
         </b-row>
         <b-row>
           <b-col>
            <MdSelect
              v-bind:Label="$tc('Shared.DrugType')"
              v-bind:Options="DrugTypeList"
              v-bind:FieldDescription="'description'"
              v-bind:FieldCode="'code'"
              v-bind:Multiple="true"
              v-bind:Model="DrugTypeModel"  
              :Input="ChangeDrugType"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <MdSelect
                v-bind:Label="$tc('ePharmacyItemsReceived.Location')"
                v-bind:Options="LocList"
                v-bind:Model="LocCodeModel"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'code'" 
                v-bind:Multiple="true"                      
                :Input="ChangeLocation"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <MdRadioGroup
              v-bind:Label="$t('ChartReview.OrderBy')"
              v-model="order"
              v-bind:Options="orderOptions"
              v-bind:Name="'order'"
            />
          </b-col>
        </b-row>
      </BaseModal>
 
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="winTitle"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="reportItemsRelocationFilters"
          :ReportName="ReportName"
          :ReportTitle="winTitle"
          :IsAnAPIReport="true"
        />
    </DxPopup>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { DxPopup } from 'devextreme-vue/popup';
  import ShowMessage from '@/components/messages/ShowMessage.js'
  import DBFunctions from '@/common/DBFunctions.js'
  import PharmacyRepFunctions from '@/common/PharmacyRepFunctions.js'
  import Utils from '@/common/utils'
  

  export default Vue.extend({
      name: "ItemsRelocationRep",
      mixins: [ ShowMessage, DBFunctions, PharmacyRepFunctions ],
      components: { DxPopup },
      props: {
        closeWindow: Function,
        winTitle: String,
        ReportName: String,
        isRelocation: Boolean,
        visible: {
            type: Boolean,
            default: false
        },
      },
      data() {
          return {
              modalId: 'itemsRelocationFilter',
              emitCloseEvent: false,
              isReportVisible: false,
              dateFrom: null,
              dateTo: null,
              reportParams: [],
              DrugList:[],
              DrugsCodeModel: [],
              LocCodeModel:'',
              LocList:[],
              parameter:{
                SearchCriteria:''
              },
              params: {
                DrugList: '',
                DrugType: '',
                LocList: ''
              },
              DrugTypeModel: '',
              DrugTypeList: [],
              orderOptions: [
                { value: '', text: this.$t('Shared.Date') },
                { value: 'DN', text: this.$t('drug.Drugname') },
              ],
              order: '',
              AuxFieldsDrugs:['status'],
              BaseFieldsDrugs:[
                  { key: 'drugCode', sortable: true, label: this.$t('Shared.DrugCode') },
                  { key: 'drugname', sortable: true, label: this.$t('ControlledDrugsRegisterRep.DrugName')},
                  { key: 'status', sortable: true, label: this.$t('Shared.Status')},
                  { key: 'form', sortable: true, label: this.$t('ControlledDrugsRegisterRep.Form')},
              ],
              isDateFromValid: true,
              isDateToValid: true, 
          }
      },
      watch: {
        visible(newVal) {
          if (newVal) {
              this.$bvModal.show(this.modalId);
              this.emitCloseEvent= true;
          }
        },
      },
      methods: {

          getValuesDrugs: function (value) {
              this.DrugsCodeModel = value
              this.params.DrugList = value.join(',')
          },

          onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0]
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px'
          },

          onHiddenReport() {
            this.isReportVisible = false
            this.closeWindow()
          },

          close() {
            this.emitEventCancel();
          },

          initializePdfParameters() {
            this.reportParams = []
            this.reportParams.push({ paramName: 'pStartDate', paramValue: this.dateFrom})
            this.reportParams.push({ paramName: 'pEndDate', paramValue: this.dateTo})
            this.reportParams.push({ paramName: 'pDrogList',paramValue: this.params.DrugList })
            this.reportParams.push({ paramName: 'pPatientCodeList',paramValue: null })
            this.reportParams.push({ paramName: 'pTran', paramValue: this.isRelocation ? 'RELOCATION' : 'REMOVED'})
            this.reportParams.push({ paramName: 'pDrugType', paramValue: this.params.DrugType})
            this.reportParams.push({ paramName: 'pLocList',paramValue: this.params.LocList })
            this.reportParams.push({ paramName: 'pOrder', paramValue: this.order})
            this.reportParams.push({ paramName: 'isUAE',  paramValue: this.$store.state.companies.isUAE})
          },

          onClickShowReport(event) {
            // Prevenir el cierre del modal
            if (event && event.preventDefault) {
              event.preventDefault();
            }
            
            // Si la validación falla, no continuar y mantener el modal abierto
            if (!this.validateForm()) {
              return; // Salir sin cerrar el modal
            }
            
            this.onHidden();
            this.initializePdfParameters();
            this.isReportVisible = true
            this.$refs.reportItemsRelocationFilters.buildDocument(this.reportParams)
          },

          onHidden() {
            if (this.emitCloseEvent) {
              this.$emit('close');
              this.emitCloseEvent= false;
            }
          },

          emitEventCancel() {
            this.emitCloseEvent= false;
            this.$emit('close');
          },

          validate_date_range() {
            return Utils.isDateFromAndDateTo(this.dateFrom, this.dateTo);
          },

          // Método de validación reutilizable
          validateForm() {
            const isValid = this.validate_date_range();
       
            this.isDateFromValid = isValid;
            this.isDateToValid = isValid;
            
            // Forzar actualización del componente
            this.$forceUpdate();
            
            if (!isValid) {
              this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.DateOutRange'), "error");
              return false;
            }
            return true;
          },
      },
      created() {
       
      },

      mounted () {
        this.getLocationsFilter();
        this.getDrugTypeFilter();
      },
  })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
